(() => {
  document.querySelectorAll('product-info.cfd-rug-page').forEach((root) => {
    if (root.dataset.rugReady) return;
    root.dataset.rugReady = 'true';
    const total = root.querySelector('[data-rug-total]');
    const value = root.querySelector('[data-rug-total-value]');
    const quantity = root.querySelector('.quantity__input');
    let price = Number(total.dataset.price);
    const format = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: total.dataset.currency || 'USD' });
    const update = () => {
      const count = Number(quantity.value);
      value.textContent = price === null ? total.dataset.unavailable : format.format(price * (Number.isFinite(count) && count > 0 ? count : 0) / 100);
    };
    quantity.addEventListener('input', update);
    quantity.addEventListener('change', update);
    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.quantityUpdate, update);
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== root.dataset.section) return;
        price = data.variant ? data.variant.price : null;
        update();
      });
    }
    update();
  });
})();
